module.exports = __webpack_public_path__ + "static/media/InvitationModalbanner.9a5b6d24.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/InvitationModalbanner.png
// module id = 788
// module chunks = 42